import React, { Component } from 'react';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import linkState from 'linkstate';
import { Icon } from '../../../icons/AppIcons';
import './device-dialog.css';

function createUuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const PORT_OPTIONS = [
  { value: 'none', label: 'Kein Anschluss', icon: 'emptyPort' },
  { value: 'fire', label: 'Feuermelder', icon: 'fire' },
  { value: 'door', label: 'Türkontakt', icon: 'door' },
];

class DeviceDialog extends Component {
  constructor(props) {
    super(props);
    this.isAddMode = true;
    let device = {
      uuid: createUuid(),
      name: '',
      lat: '',
      long: '',
      active: 1,
      port_1: 'none',
      port_2: 'none',
      port_3: 'none',
      port_4: 'none',
    };

    if (props.panelData || props.deviceData) {
      this.isAddMode = false;
      const src = props.deviceData || props.panelData;
      device = {
        id: src.id,
        uuid: src.uuid || '',
        name: src.name || '',
        lat: src.lat ?? '',
        long: src.long ?? '',
        active: src.active ? 1 : 0,
        port_1: src.port_1 || 'none',
        port_2: src.port_2 || 'none',
        port_3: src.port_3 || 'none',
        port_4: src.port_4 || 'none',
      };
    }

    this.state = { device };
  }

  setPort(key, value) {
    this.setState({
      device: { ...this.state.device, [key]: value },
    });
  }

  renderPortSelect(key, label) {
    return (
      <FormControl fullWidth margin="dense" variant="outlined">
        <InputLabel id={`${key}-label`}>{label}</InputLabel>
        <Select
          labelId={`${key}-label`}
          id={key}
          label={label}
          value={this.state.device[key] || 'none'}
          onChange={(e) => this.setPort(key, e.target.value)}
        >
          {PORT_OPTIONS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              <span className="fc-name-cell">
                <Icon name={opt.icon} size={18} />
                {opt.label}
              </span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  render() {
    return (
      <div>
        <DialogTitle id="form-dialog-title">
          Koffer {this.isAddMode ? 'Erstellen' : 'Bearbeiten'}
        </DialogTitle>
        <DialogContent>
          <div className="p-line-one">
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Name"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.device.name}
              onInput={linkState(this, 'device.name')}
            />
          </div>
          <div className="p-line-one">
            <TextField
              margin="dense"
              id="uuid"
              label="UUID"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.device.uuid}
              onInput={linkState(this, 'device.uuid')}
            />
          </div>
          <div className="p-line-two">
            <TextField
              margin="dense"
              id="lat"
              label="Lat"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.device.lat}
              onInput={linkState(this, 'device.lat')}
            />
            <TextField
              margin="dense"
              id="long"
              label="Long"
              type="text"
              fullWidth
              variant="outlined"
              value={this.state.device.long}
              onInput={linkState(this, 'device.long')}
            />
          </div>
          <div className="p-line-one">
            <FormControlLabel
              control={
                <Switch
                  checked={!!this.state.device.active}
                  onChange={(e) =>
                    this.setState({
                      device: { ...this.state.device, active: e.target.checked ? 1 : 0 },
                    })
                  }
                  color="primary"
                />
              }
              label="Aktiv"
            />
          </div>
          <div className="p-line-two">
            {this.renderPortSelect('port_1', 'Anschluss 1')}
            {this.renderPortSelect('port_2', 'Anschluss 2')}
          </div>
          <div className="p-line-two">
            {this.renderPortSelect('port_3', 'Anschluss 3')}
            {this.renderPortSelect('port_4', 'Anschluss 4')}
          </div>
        </DialogContent>
        <DialogActions>
          <div className="p-line-end">
            <Button variant="outlined" onClick={this.props.close}>
              Abbrechen
            </Button>
            <span />
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.props.submit({ device: this.state.device, panel: this.state.device })}
            >
              Speichern
            </Button>
          </div>
        </DialogActions>
      </div>
    );
  }
}

export default DeviceDialog;
